module.exports = __webpack_public_path__ + "static/media/service.795a00e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/categories/service.svg
// module id = 271
// module chunks = 0